import { render, staticRenderFns } from "./uclConfig.vue?vue&type=template&id=064199d4&scoped=true&"
import script from "./uclConfig.vue?vue&type=script&lang=js&"
export * from "./uclConfig.vue?vue&type=script&lang=js&"
import style0 from "./uclConfig.vue?vue&type=style&index=0&id=064199d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064199d4",
  null
  
)

export default component.exports